import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/template/modal/edit';

const EditButton = ({ template, space, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="contained"
      disabled={!space.adminRole}
      onClick={() => {
        addModal(
          <Edit
            template={template}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.template.edited');
            }}
            handleClose={() => removeModal()}
          />
        );
      }}
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
